<div class="row" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <div class="col-sm-3" style="display:flex;">
        <h4 class="page-label" style="text-align: left; align-self: end;">Selected Portal: {{ portal?.name }}</h4>
    </div>
    <div class="col-sm-6">
        <h1 class="page-label">Portal Validation - Dashboard</h1>
    </div>
    <div class="col-sm-3" style="display:flex;">
        <h4 class="page-label" style="text-align: right; align-self: end;">{{ getUserInputForOrder() }}</h4>
    </div>
</div>


<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table" role="grid" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <thead>
        <tr role="row" class="tablesorter-headerRow">
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="checkbox checkbox-inline">
                    <input type="checkbox" class="styled"
                        (click)="selectAllLineItems($event.target.checked)"
                        [checked]="isAllLineItemsSelected()"
                        [disabled]="isSelectingAllLineItems || isProcessActionBeingProcessed">
                    <label></label>
                </div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">ASN #</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">PO #</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Material Number</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Material Description</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Required Quantity</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Scanned Quantity</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Completed Quantity</div>
            </th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">
                <div class="tablesorter-header-inner">Balance Quantity</div>
            </th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let lineItem of state?.line_items; index as i;">
            <tr role="row" [class.green-highlight]="isSuccessRow(lineItem)" [class.red-highlight]="isErrorRow(lineItem)" [class.yellow-highlight]="isPartialRow(lineItem)" [class.gray-highlight]="isUnknownRow(lineItem)">
                <td [rowSpan]="lineItem.sub_rows.length == 0? 1 : lineItem.sub_rows.length + 2">
                    <div class="checkbox checkbox-inline">
                        <input type="checkbox" class="styled"
                            (click)="onLineItemToggled(lineItem, $event.target.checked, i)"
                            [disabled]="isSelectingAllLineItems || isProcessActionBeingProcessed"
                            [checked]="isLineItemSelected(lineItem, i)"
                            >
                        <label></label>
                    </div>
                </td>
                <td [rowSpan]="lineItem.sub_rows.length == 0? 1 : lineItem.sub_rows.length + 2">
                    {{ lineItem?.asn }}
                </td>
                <td [rowSpan]="lineItem.sub_rows.length == 0? 1 : lineItem.sub_rows.length + 2">
                    {{ lineItem?.po }}
                </td>
                <td [rowSpan]="lineItem.sub_rows.length == 0? 1 : lineItem.sub_rows.length + 2">
                    {{ lineItem?.material_number }}
                </td>
                <td>
                    {{ lineItem?.material_description }}
                </td>
                <td>
                    {{ lineItem?.required_quantity }}
                </td>
                <td *ngIf="isReaderStarted()">
                    {{ lineItem?.scanned_quantity }} {{ getInputScannedQuantityFormattedForDisplay(lineItem) }}
                </td>
                <td *ngIf="!isReaderStarted()">
                    <input class="form-control" type="number" inputmode="numeric" (ngModelChange)="onInputScannedQuantityChanged(lineItem, $event)" [ngModel]="getInputScannedQuantity(lineItem)" [delay]="1000" style="margin: 0; display: inline-block; width: auto;" [disabled]="isProcessActionBeingProcessed">&nbsp;{{ getActualScannedQuantityFormattedForDisplay(lineItem) }}
                </td>
                <td [rowSpan]="lineItem.sub_rows.length == 0? 1 : lineItem.sub_rows.length + 2">
                    {{ lineItem?.completed_quantity }}
                </td>
                <td [rowSpan]="lineItem.sub_rows.length == 0? 1 : lineItem.sub_rows.length + 2">
                    {{ lineItem?.balance_quantity }}
                </td>
            </tr>
            <tr *ngIf="lineItem.sub_rows.length > 0">
                <!-- <td></td> <!-- Checkbox -->
                <!-- <td></td> <!-- ASN -->
                <!-- <td></td> <!-- PO -->
                <!-- <td></td> <!-- Material Number -->
                <td>Batch</td> <!-- Material Description -->
                <td>Company</td> <!-- Required Quantity -->
                <td>Scanned Quantity</td> <!-- Scanned Quantity - IF READER STARTED -->
                <!-- <td></td> <!-- Completed Quantity -->
                <!-- <td></td> <!-- Balance Quantity -->
            </tr>
            <tr *ngFor="let subrow of lineItem.sub_rows">
                <!-- <td></td> <!-- Checkbox -->
                <!-- <td></td> <!-- ASN -->
                <!-- <td></td> <!-- PO -->
                <!-- <td></td> <!-- Material Number -->
                <td>{{ subrow.batch }}</td> <!-- Material Description -->
                <td>{{ subrow.company }}</td> <!-- Required Quantity -->
                <td>{{ subrow.scanned_quantity }}</td> <!-- Scanned Quantity - IF READER STARTED -->
                <!-- <td></td> <!-- Completed Quantity -->
                <!-- <td></td> <!-- Balance Quantity -->
            </tr>
        </ng-container>
    </tbody>
</table>

<div class="row" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <div class="col-sm-3">
        <button class="submit btn btn-primary" (click)="onStartReaderClicked()" [disabled]="isReaderStarted() || isReaderActionBeingProcessed || isProcessActionBeingProcessed">Start Reader</button>
        &nbsp;
        <button class="submit btn btn-primary" (click)="onStopReaderClicked()" [disabled]="!isReaderStarted() || isReaderActionBeingProcessed || isProcessActionBeingProcessed">Stop Reader</button>
    </div>
    <div class="col-sm-6">

    </div>
    <div class="col-sm-3">
        <button class="submit btn btn-primary" (click)="onClearOrderClicked()" [disabled]="isReaderStarted() || isClearOrderBeingProcessed || isReaderActionBeingProcessed || isProcessActionBeingProcessed">Clear Order</button>
        &nbsp;
        <button class="submit btn btn-primary" (click)="onProcessClicked()" [disabled]="isReaderStarted() || isClearOrderBeingProcessed || isReaderActionBeingProcessed || isProcessActionBeingProcessed">Process Order</button>
    </div>
</div>

<div class="print-container">
    <h1 class="page-label">&nbsp;</h1>
</div>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog
    >
</ef-simple-indefinite-progress-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
